import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_HOMEPAGE_NOTICE = createFcmDetails('homepage_notice', {
	// owner: '',
	context: 'Homepage',
	description: `Used to display a notice on the homepage.
		The "xxx_prefix" is some bold uppercase text displayed before the copy.
		The "url" and "xxx_link_text" are used to generate a link.
`,
	template: {
		desktop_prefix: 'TODO',
		desktop_copy: 'TODO',
		desktop_link_text: 'TODO',
		mobile_prefix: 'TODO',
		mobile_copy: 'TODO',
		mobile_link_text: 'TODO',
		url: 'https://www.change.org',
	},
	import: false,
});
